import { FaDollarSign, FaMusic } from "react-icons/fa"; // icon for music
import { VscAccount } from "react-icons/vsc"; // icon for account
import { ImHeadphones } from "react-icons/im"; // icon for audio book
import { FaListAlt } from "react-icons/fa"; // icon for audio category list
import { HiUserGroup } from "react-icons/hi"; // icon for audio all publishers
import { BiSolidPlaylist } from "react-icons/bi"; // icon for music playlist
import { FaReadme } from "react-icons/fa6"; // icon for terms and conditiosn
import { FaQuestionCircle } from "react-icons/fa";
import { CircleDollarSignIcon, DollarSign, File, User } from "lucide-react";
import { QuestionMark } from "@mui/icons-material";

const colorCode = "#eab308";

export const SideBarList = [

    {
        link : null,
        icon : null,
        colorCode : colorCode,
        children : [
            {
                title : "Music",
                link : "music",
                icon : FaMusic,
            },
            {
                title : "Audio Book",
                link : "audio",
                icon : ImHeadphones
            },
            {
                title : "ကိုယ်ပိုင်အကောင့်",
                link : "account/my-account",
                icon : User
            },
            // {
            //     title : "ငွေဖြည့်ရန်",
            //     link : "credit-fill",
            //     icon : CircleDollarSignIcon
            // },
            {
                title : "စည်းမျဉ်းစည်းကမ်းများ",
                link : "account/t_&_C",
                icon : File
            },
            {
                title : "မေးလေ့ရှိသောမေးခွန်းများ",
                link : "account/f_a_q",
                icon : QuestionMark
            }
        ]
    },
    
    {
        title : "Audio Book",
        link : null,
        icon : null,
        colorCode : colorCode,
        children : [
            // {
            //     title : "အသံသွင်း စာအုပ်များ",
            //     link : "audio",
            //     icon : ImHeadphones,
            // },
            {
                title : "စာအုပ် အမျိုးအစားများ",
                link : "audio/category-list",
                icon : FaListAlt
            },
            // {
            //     title : "မိမိ စာအုပ်များ",
            //     link : "audio/purchased-books",
            //     icon : ImHeadphones
            // },
            {
                title : "စာရေးဆရာများ",
                link : "audio/all-publishers",
                icon : HiUserGroup
            }
        ]
    },
    {
        title : "Music",
        link : null,
        icon : null,
        colorCode : colorCode,
        children : [
            {
                title : "သီချင်းများ",
                link : "/",
                icon : FaMusic
            },
            {
                title : "SNS's Playlist",
                link : "/music/see_all/5/playlist",
                icon : BiSolidPlaylist
            },
            {
                title : "အဆိုတော်များ",
                link : "/music/see_all/4/artist",
                icon : HiUserGroup
            }
        ]
    },
    // {
    //     title : "Account",
    //     link : null,
    //     icon : null,
    //     colorCode : colorCode,
    //     children : [
    //         {
    //             title : "ကိုယ်ပိုင်အကောင့်",
    //             link : "account/my-account",
    //             icon : ImHeadphones,
    //         },
    //         {
    //             title : "စည်းမျဉ်းစည်ကမ်းများ",
    //             link : "account/t_&_C",
    //             icon : FaReadme
    //         },
    //         {
    //             title : "မေးလေ့ရှိသော မေးခွန်းများ",
    //             link : "account/f_a_q",
    //             icon : FaQuestionCircle
    //         },
    //     ]
    // }
];

// export const SideBarList = [
    
//     {
//         title : "Audio Book",
//         link : null,
//         icon : null,
//         colorCode : colorCode,
//         children : [
//             {
//                 title : "အသံသွင်း စာအုပ်များ",
//                 link : "audio",
//                 icon : ImHeadphones,
//             },
//             {
//                 title : "စာအုပ် အမျိုးအစားများ",
//                 link : "audio/category-list",
//                 icon : FaListAlt
//             },
//             {
//                 title : "စာရေးဆရာများ",
//                 link : "audio/all-publishers",
//                 icon : HiUserGroup
//             }
//         ]
//     },
//     {
//         title : "Music",
//         link : null,
//         icon : null,
//         colorCode : colorCode,
//         children : [
//             {
//                 title : "သီချင်းများ",
//                 link : "/",
//                 icon : FaMusic
//             },
//             {
//                 title : "SNS's Playlist",
//                 link : "/music/see_all/5/playlist",
//                 icon : BiSolidPlaylist
//             },
//             {
//                 title : "အဆိုတော်များ",
//                 link : "/music/see_all/4/artist",
//                 icon : HiUserGroup
//             }
//         ]
//     },
//     {
//         title : "Account",
//         link : null,
//         icon : null,
//         colorCode : colorCode,
//         children : [
//             {
//                 title : "ကိုယ်ပိုင်အကောင့်",
//                 link : "account/my-account",
//                 icon : ImHeadphones,
//             },
//             {
//                 title : "စည်းမျဉ်းစည်ကမ်းများ",
//                 link : "account/t_&_C",
//                 icon : FaReadme
//             },
//             {
//                 title : "မေးလေ့ရှိသော မေးခွန်းများ",
//                 link : "account/f_a_q",
//                 icon : FaQuestionCircle
//             },
//         ]
//     }
// ];
